const routeContacts = () => '/contacts';

export default routeContacts;
